import { render, staticRenderFns } from "./Businesses.vue?vue&type=template&id=20dbbdd6&"
import script from "./Businesses.vue?vue&type=script&lang=js&"
export * from "./Businesses.vue?vue&type=script&lang=js&"
import style0 from "./Businesses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports